module.exports = __webpack_public_path__ + "img/facebook.91982fb7.svg";